export const PremiumBreakdownConfigs = {
    accordionCollapse:{
        van: true,
        motor: true,
        home: true,
        device: true,
        travel: true
    }
}